import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'الرئيسية', path: '/' },
    { name: 'من نحن', path: '/about' },
    { name: 'خدماتنا', path: '/services' },
    { name: 'الرافعات', path: '/cranes' },
    { name: 'مشاريعنا', path: '/projects' },
    { name: 'معرض الصور', path: '/gallery' },
    { name: 'معرض الفيديوهات', path: '/videos' },
    { name: 'تواصل معنا', path: '/contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img
              src="https://static.readdy.ai/image/8f4b99b6f50522f57c0c4089909ec764/cec408eade00b7f2bb8d035c2ad6c56f.png"
              alt="روافع المتحدون للمقاولات"
              className="h-14 w-auto object-contain"
            />
          </Link>

          {/* Navigation Links */}
          <div className="flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-base font-semibold transition-colors whitespace-nowrap ${
                  location.pathname === link.path
                    ? isScrolled
                      ? 'text-accent'
                      : 'text-accent'
                    : isScrolled
                    ? 'text-primary hover:text-accent'
                    : 'text-white hover:text-accent'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <a
            href="tel:920000000"
            className="bg-accent hover:bg-accent-dark text-primary px-6 py-3 rounded-lg font-bold text-sm transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer flex items-center gap-2"
          >
            <i className="ri-phone-fill"></i>
            <span>اتصل بنا الآن</span>
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;